import React, { useCallback, useEffect, useState } from 'react';
import PHOTOS from '../data/photos';

function Photos() {
  const [open, setOpen] = useState(null);

  const step = useCallback((d) => setOpen((i) => (i + d + PHOTOS.length) % PHOTOS.length), []);

  useEffect(() => {
    if (open === null) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') setOpen(null);
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    };
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => { document.removeEventListener('keydown', onKey); document.body.style.overflow = ''; };
  }, [open, step]);

  return (
    <section className="block block-wide page-block" aria-labelledby="photos-title">
      <div className="block-head">
        <h1 id="photos-title">Photos</h1>
      </div>

      <div className="photos">
        {PHOTOS.map((p, i) => (
          <button key={p.src} className="photo" onClick={() => setOpen(i)} aria-label={`Open ${p.alt || 'photo'}`}>
            <img src={p.src} alt={p.alt} loading="lazy" decoding="async" />
          </button>
        ))}
      </div>

      {open !== null && (
        <div className="lightbox" role="dialog" aria-modal="true" aria-label="Photo viewer" onClick={() => setOpen(null)}>
          <img src={PHOTOS[open].src} alt={PHOTOS[open].alt} onClick={(e) => e.stopPropagation()} />
          <button className="lb-btn lb-prev" aria-label="Previous photo" onClick={(e) => { e.stopPropagation(); step(-1); }}>
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 5l-7 7 7 7" /></svg>
          </button>
          <button className="lb-btn lb-next" aria-label="Next photo" onClick={(e) => { e.stopPropagation(); step(1); }}>
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 5l7 7-7 7" /></svg>
          </button>
          <button className="lb-btn lb-close" aria-label="Close" onClick={() => setOpen(null)}>
            <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" /></svg>
          </button>
          <span className="lb-count">{open + 1} / {PHOTOS.length}</span>
        </div>
      )}
    </section>
  );
}

export default Photos;
